import { render, staticRenderFns } from "./detail-component-checkins.vue?vue&type=template&id=3bb331f3&scoped=true"
import script from "./detail-component-checkins.vue?vue&type=script&lang=ts"
export * from "./detail-component-checkins.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb331f3",
  null
  
)

export default component.exports